import { render, staticRenderFns } from "./pure.vue?vue&type=template&id=1c63e9ba&scoped=true"
import script from "./pure.vue?vue&type=script&setup=true&lang=js"
export * from "./pure.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63e9ba",
  null
  
)

export default component.exports